import {defaultApi} from '@/axios'
import {safeParseIsoDate} from '@/utils/parse'

export enum Tier {
  DISABLED = 'DISABLED',
  CUSTOM = 'CUSTOM',
  SMART = 'SMART',
}

export enum DripInterval {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}

export interface CreditUsageFromApi {
  tier: Tier
  isActiveTier: boolean
  dripInterval?: DripInterval
  periodQuotaCredits: number
  periodCreditsIncludingTopUps: number
  releasedCredits: number
  availableCredits: number
  consumedCredits: number
  unreleasedCredits: number
  nextCreditReleaseDate?: string
  nextCreditReleaseAmount?: number
}

export interface CreditUsage extends Omit<CreditUsageFromApi, 'nextCreditReleaseDate'> {
  nextCreditReleaseDate?: Date
}

export class CreditUsageClient {
  async getCreditUsage(companyId: number): Promise<CreditUsage> {
    const params = {companyId}
    return defaultApi.get<CreditUsageFromApi>('/api/mentor/credit-usage', {params}).then((res) => parseCreditUsage(res.data))
  }
}

function parseCreditUsage(creditUsage: CreditUsageFromApi): CreditUsage {
  return {
    ...creditUsage,
    nextCreditReleaseDate: creditUsage.nextCreditReleaseDate ? safeParseIsoDate(creditUsage.nextCreditReleaseDate) : undefined,
  }
}

const creditUsageClient = new CreditUsageClient()

export default creditUsageClient
